// Reusable framer-motion variants for consistent, smooth animations.
export const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.35, ease: "easeOut" } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.96 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] } },
};

export const stagger = (delayChildren = 0.05, staggerChildren = 0.06) => ({
  hidden: {},
  show: {
    transition: { delayChildren, staggerChildren },
  },
});

// Hover-lift preset — use on cards
export const hoverLift = {
  whileHover: { y: -3, transition: { duration: 0.2, ease: "easeOut" } },
  whileTap: { scale: 0.98 },
};

// Small chip pop-in
export const chipPop = {
  hidden: { opacity: 0, scale: 0.7 },
  show: { opacity: 1, scale: 1, transition: { type: "spring", stiffness: 500, damping: 30 } },
  exit: { opacity: 0, scale: 0.7, transition: { duration: 0.15 } },
};

// Page mount transition
export const pageEnter = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, y: -6, transition: { duration: 0.2 } },
};
